import {
  GuestFillInDetails,
  MultRoomGuestFillInDetails,
} from './GuestFillInDetails';
import FillInDetails from './FillInDetails';
import BookerFillInDetails from './BookerFillInDetails';

export {
  GuestFillInDetails,
  FillInDetails,
  BookerFillInDetails,
  MultRoomGuestFillInDetails,
};
